import React from 'react'
import { loadStripe } from '@stripe/stripe-js'

export function StripeLoader({ children, stripePublishableKey }) {
	global.stripePromise = loadStripe(stripePublishableKey)
	return <>{children}</>
}
